/*
 * customization: fetchCreateNewWishlist
 */

import { wishListCreator } from '@/core/data/Content/_Wishlists';
import { WISHLIST_STATE } from '@/data/constants/wishlist';
import { RequestQuery } from '@/data/types/RequestQuery';
import { RequestParams } from 'integration/generated/transactions/http-client';

export const fetchCreateNewWishlist =
	(pub: boolean) =>
	async (
		storeId: string,
		query: RequestQuery | undefined,
		wishlistName: string,
		params?: RequestParams
	) => {
		let wishlistId = '';
		const list = await wishListCreator(pub)(
			storeId,
			{ description: wishlistName, registry: false, state: WISHLIST_STATE.DEFAULT },
			undefined,
			params ?? {}
		);
		wishlistId = list.uniqueID;

		return { wishlistId };
	};

export * from '@/core/data/Content/_Wishlists';
